import React from 'react';
import {Card, Grid, Button, Header, Loader, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import {Toggle} from 'componentLibrary';
import _ from 'lodash';

export default class TaskResults extends React.Component {
  render() {
    const {results, assignTask, unassignTask, userId} = this.props;
    const cards = _.map(results, (result, index) => {
      const matchFundOpp = _.find(this.props.fundingOpps, (fundingOpportunity) => {
        return fundingOpportunity.fundingOpportunityId == result.fundingOpportunityId;
      });
      const fundOppName = _.get(matchFundOpp, 'fundingOpportunityName', '');

      const matchIdToName = _.find(this.props.userObjs, (obj) => {
        return obj.userId === result.assignee;
      });
      const userIdEmail = _.get(matchIdToName, 'emailAdr', '');

      const subApplication = _.get(result, 'subApplication');
      const isSubGrantTask = !_.isEmpty(subApplication);
      const grantId = _.get(result, 'grantId');
      return (
        <Card key={`taskCard${index}`} fluid>
          <Grid celled="internally">
            {/* </Grid>isSubGrantTask ? <subgrant card> : grantId ? <grantCard> : <focard> */}
            {isSubGrantTask ? (
              <React.Fragment>
                <Grid.Column width={6}>
                  <Grid columns={2}>
                    <Grid.Column>
                      <Header as="h6">Suborganization</Header>
                      {result.subOrganizationName}
                      <Header as="h6">Subgrant Id</Header>
                      <Link to={`/subgrant/${subApplication.subGrantId}`} target="_blank">
                        {_.get(subApplication, 'subGrantId', '')}
                      </Link>
                    </Grid.Column>
                    <Grid.Column>
                      <Header as="h6">Subapplication Type</Header>
                      {_.get(subApplication, 'subApplicationTypeDesc', '')}
                      <Header as="h6">Funding Category</Header>
                      {_.get(result, 'liveFundingCategory') ||
                        _.get(result, 'subApplicationCategory') ||
                        _.get(result, [
                          'subApplicationCategoryMap',
                          subApplication.subApplicationId,
                        ])}
                    </Grid.Column>
                  </Grid>
                </Grid.Column>

                <Grid.Column width={6}>
                  <Grid columns={2}>
                    <Grid.Column>
                      <Header as="h6">Organization</Header>
                      {result.organizationName}
                      <Header as="h6">Region</Header>
                      {result.region}
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                      <Header as="h6">Date in queue</Header>
                      {new Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }).format(result.created)}
                      <Header as="h6">Task</Header>
                      {result.name}
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </React.Fragment>
            ) : grantId ? (
              <React.Fragment>
                <Grid.Column width={4}>
                  <Header as="h6">Organization</Header>
                  {result.organizationName}
                  <Header as="h6">Priority Rank</Header>
                  {result.priorityDisplay}
                  <Header as="h6">Region</Header>
                  {result.region}
                </Grid.Column>

                <Grid.Column width={8}>
                  <Grid columns={2}>
                    <Grid.Column>
                      <Header as="h6">Grant ID</Header>
                      <Link
                        to={`/grant/${result.grantId}`}
                        target="_blank"
                        title={result.grantId}
                        id="content"
                      >
                        {result.grantId}
                        <Icon name="external alternate" />
                      </Link>
                      <Header as="h6">Funding Opportunity</Header>
                      {fundOppName}
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                      <Header as="h6">Date in queue</Header>
                      {new Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }).format(result.created)}
                      <Header as="h6">Task</Header>
                      {result.name}
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Grid.Column width={4}>
                  <Header as="h6">Region</Header>
                  {result.region}
                </Grid.Column>
                <Grid.Column width={8}>
                  <Grid columns={2}>
                    <Grid.Column>
                      <Header as="h6">Funding Opportunity</Header>
                      {fundOppName}
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                      <Header as="h6">Date in queue</Header>
                      {new Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }).format(result.created)}
                      <Header as="h6">Task</Header>
                      {result.name}
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </React.Fragment>
            )}

            <Grid.Column width={4}>
              <Grid.Column textAlign="left">
                <Header as="h6">Assigned to</Header>
                {!result.assignee && (
                  <React.Fragment>
                    {' '}
                    Unassigned <br />{' '}
                    {!_.includes(result.excludedPerformer, userId) ? (
                      <Button
                        style={{
                          position: 'absolute',
                          bottom: '1em',
                          left: '1em',
                        }}
                        primary
                        onClick={() => assignTask(result.id)}
                        title={'Start task for: ' + result.grantId + ' ' + result.name}
                      >
                        Start task
                      </Button>
                    ) : (
                      <React.Fragment>
                        <br />
                        You are not eligible to complete this task
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
                {result.assignee && (
                  <React.Fragment>
                    {userIdEmail}{' '}
                    <a
                      className="table-link"
                      href="#"
                      title={'Unassign task ' + result.grantId}
                      onClick={() => unassignTask(result.id)}
                    >
                      (Unassign)
                    </a>
                  </React.Fragment>
                )}
                {result.assignee && result.assignee === userId && (
                  <Link
                    title={
                      'Continue working task for: ' + result.grantId + ' ' + result.name
                    }
                    label="continue task"
                    to={`/tasks/${result.id}`}
                  >
                    <Button
                      style={{
                        position: 'absolute',
                        bottom: '1em',
                        left: '1em',
                      }}
                      title={
                        'Continue working task for: ' + result.grantId + ' ' + result.name
                      }
                      primary
                    >
                      Continue working
                    </Button>
                  </Link>
                )}
              </Grid.Column>
            </Grid.Column>
          </Grid>
        </Card>
      );
    });

    return (
      <InfiniteScroll
        className="ui cards"
        dataLength={cards.length}
        next={this.props.fetchMoreData}
        hasMore={this.props.hasMore}
        scrollableTarget={'root'}
        loader={
          <Loader inline="centered" active>
            Loading...
          </Loader>
        }
      >
        {cards}
      </InfiniteScroll>
    );
  }
}
